var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMazeComponent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 348.0 348.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l348.0 0l0 348.0l-348.0 0l0 -348.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l348.0 0l0 348.0l-348.0 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m-6.0 0l354.01575 0l0 347.9685l-354.01575 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m5.07874 5.7758217l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m5.07874 5.7758217l336.9134 0l0 337.6693l-336.9134 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m282.73444 40.553925l0 0c0 -8.375591 6.966034 -15.165352 15.5590515 -15.165352l0 0c4.126526 0 8.084015 1.5977726 11.001923 4.441828c2.9178772 2.844057 4.557129 6.7014217 4.557129 10.723524l0 0c0 8.375595 -6.9660034 15.165356 -15.5590515 15.165356l0 0c-8.593018 0 -15.5590515 -6.7897606 -15.5590515 -15.165356z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m42.7231 62.12861l263.1496 0l0 246.07877l-263.1496 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m42.7231 62.12861l263.1496 0l0 246.07877l-263.1496 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m32.884514 147.93439l-22.866142 26.67717l22.866142 26.677155z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m32.884514 147.93439l-22.866142 26.67717l22.866142 26.677155z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m313.85303 201.28871l22.86612 -26.67717l-22.86612 -26.677155z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m313.85303 201.28871l22.86612 -26.67717l-22.86612 -26.677155z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m146.69029 316.95013l26.67717 22.86615l26.677155 -22.86615z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m146.69029 316.95013l26.67717 22.86615l26.677155 -22.86615z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m146.69029 53.385826l26.67717 -22.86614l26.677155 22.86614z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m146.69029 53.385826l26.67717 -22.86614l26.677155 22.86614z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.07997 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m224.07997 81.81365l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 81.81365l17.700806 0l0 16.472435l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 81.81365l17.700806 0l0 16.472435l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.07997 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m224.07997 117.59475l17.70079 0l0 16.472435l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 117.59475l17.700806 0l0 16.472435l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 117.59475l17.700806 0l0 16.472435l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.07997 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m224.07997 153.37585l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 153.37585l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 153.37585l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 189.15695l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 189.15695l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 189.15695l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.07997 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m224.07997 224.93805l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 224.93805l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 224.93805l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m67.72966 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m67.72966 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m106.81724 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m106.81724 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m145.90482 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m145.90482 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m184.99239 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m184.99239 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m224.07997 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m224.07997 260.71915l17.70079 0l0 16.472443l-17.70079 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m263.16754 260.71915l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m263.16754 260.71915l17.700806 0l0 16.472443l-17.700806 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m95.24147 161.61285l0 0c0 -10.95871 9.017761 -19.842514 20.141731 -19.842514l0 0c5.341919 0 10.46505 2.0905457 14.242363 5.811737c3.777298 3.7211914 5.8993683 8.768219 5.8993683 14.030777l0 0c0 10.958725 -9.017761 19.84253 -20.141731 19.84253l0 0c-11.12397 0 -20.141731 -8.883804 -20.141731 -19.84253z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.24147 161.61285l0 0c0 -10.95871 9.017761 -19.842514 20.141731 -19.842514l0 0c5.341919 0 10.46505 2.0905457 14.242363 5.811737c3.777298 3.7211914 5.8993683 8.768219 5.8993683 14.030777l0 0c0 10.958725 -9.017761 19.84253 -20.141731 19.84253l0 0c-11.12397 0 -20.141731 -8.883804 -20.141731 -19.84253z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m212.59055 125.8294l0 0c0 -10.958725 9.017761 -19.842522 20.141739 -19.842522l0 0c5.341919 0 10.465042 2.0905457 14.242355 5.811737c3.7773132 3.721199 5.8993835 8.768219 5.8993835 14.030785l0 0c0 10.958717 -9.017761 19.842522 -20.141739 19.842522l0 0c-11.123978 0 -20.141739 -8.883804 -20.141739 -19.842522z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m212.59055 125.8294l0 0c0 -10.958725 9.017761 -19.842522 20.141739 -19.842522l0 0c5.341919 0 10.465042 2.0905457 14.242355 5.811737c3.7773132 3.721199 5.8993835 8.768219 5.8993835 14.030785l0 0c0 10.958717 -9.017761 19.842522 -20.141739 19.842522l0 0c-11.123978 0 -20.141739 -8.883804 -20.141739 -19.842522z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "m212.59027 208.32964l34.99211 4.141739l-12.314957 -32.960632z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m212.59027 208.32964l34.99211 4.141739l-12.314957 -32.960632z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMazeComponent);
export default __webpack_public_path__ + "static/media/MazeComponent.24cd57d0f81c41091d96f21ae209b3fa.svg";
export { ForwardRef as ReactComponent };